import styled from 'styled-components'

import BasicDetail from './BasicDetail'
import DispatchLocation from './DispatchLocation'
import DistanceProgress from './DistanceProgress'
import POD from './POD'
import VehicleDetails from './VehicleDetails'
import useBasicDetails from './useBasicDetails'
import { Spacings } from '@styles'

const CardsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
`

const BasicDetails = ({ supplierPoNumber, update, editable = false, deliveryOnly = false, vehicleEditable = false, podEditable = false }) => {
	const {
		invoiceData,
		order,
		completedIndex,
		fillPercent,
		showTransit,
		transitPercent,
		transitDone,
		displayTotal,
		displayCovered,
		displayRemaining,
		loadedDate,
		inTransitDate,
		deliveredDate,
	} = useBasicDetails()

	return (
		<>
			<DistanceProgress
				completedIndex={completedIndex}
				fillPercent={fillPercent}
				showTransit={showTransit}
				transitPercent={transitPercent}
				transitDone={transitDone}
				displayTotal={displayTotal}
				displayCovered={displayCovered}
				displayRemaining={displayRemaining}
				loadedDate={loadedDate}
				inTransitDate={inTransitDate}
				deliveredDate={deliveredDate}
			/>
			<CardsWrapper>
				<BasicDetail
					invoiceData={invoiceData}
					order={order}
					supplierPoNumber={supplierPoNumber}
					update={update}
					editable={editable || deliveryOnly}
					deliveryOnly={deliveryOnly}
				/>
				<VehicleDetails
					invoiceData={invoiceData}
					order={order}
					supplierPoNumber={supplierPoNumber}
					update={update}
					editable={vehicleEditable}
				/>
				<DispatchLocation
					invoiceData={invoiceData}
					order={order}
					supplierPoNumber={supplierPoNumber}
					update={update}
					editable={vehicleEditable}
				/>
				{!supplierPoNumber && (
					<POD invoiceData={invoiceData} order={order} supplierPoNumber={supplierPoNumber} update={update} editable={podEditable} />
				)}
			</CardsWrapper>
		</>
	)
}

export default BasicDetails
